export interface Article {
  id: string;
  title: string;
  slug: string;
  categoryId: string;
  categoryName: string;
  excerpt: string;
  content: string;
  author: string;
  authorAvatar: string;
  publishDate: string;
  readTime: number;
  imageUrl: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '2026年男同交友安全指南：如何保护自己',
    slug: '2026-dating-safety-guide',
    categoryId: 'jiaoyou',
    categoryName: '男同交友',
    excerpt: '在数字时代，男同交友变得更加便捷，但安全问题不容忽视。本文为你梳理了从线上到线下全流程的安全注意事项。',
    content: `<p>在数字时代，男同交友变得更加便捷，但安全问题不容忽视。本文为你梳理了从线上到线下全流程的安全注意事项，帮助你在享受社交乐趣的同时保护好自己。</p>

<h2>一、线上交友平台选择</h2>
<p>选择靠谱的交友平台是第一道防线。建议优先选择实名认证严格、隐私保护到位的平台。男同网作为专为男同群体打造的平台，严格审核用户信息，确保社区环境安全友好。</p>

<h2>二、个人信息保护</h2>
<p>在初次交流时，避免透露过多个人信息。包括但不限于：家庭住址、工作单位、身份证号、银行账户等敏感信息。可以先通过平台内置的聊天功能进行沟通，待建立信任后再逐步分享更多信息。</p>

<h2>三、首次见面注意事项</h2>
<p>首次线下见面建议选择人流量较大的公共场所，如咖啡厅、餐厅或商场。提前告知好友你的行程安排，包括见面地点、时间和对方基本信息。保持手机电量充足，随时保持联系。</p>

<h2>四、建立健康的关系</h2>
<p>健康的关系建立在相互尊重的基础上。如果对方有任何让你感到不适的行为，你有权利说"不"。记住，真正在乎你的人会尊重你的边界和选择。</p>

<h2>五、遇到问题及时求助</h2>
<p>如果在交友过程中遇到骚扰、威胁或其他安全问题，不要犹豫，立即向平台举报或向当地警方求助。你并不孤单，整个社群都是你的后盾。</p>`,
    author: '小明',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20Asian%20male%20portrait%20avatar%20with%20gentle%20smile%20on%20soft%20peach%20gradient%20background%20minimal%20illustration%20style%20clean%20modern&width=100&height=100&seq=avatar-01&orientation=squarish',
    publishDate: '2026-08-05',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20men%20having%20coffee%20at%20a%20bright%20modern%20cafe%20with%20warm%20lighting%20friendly%20atmosphere%20soft%20natural%20colors%20editorial%20photography%20clean%20composition&width=800&height=450&seq=article-01&orientation=landscape',
    tags: ['交友安全', '防骗指南', '社交技巧'],
    featured: true,
  },
  {
    id: '2',
    title: '出柜后的生活：如何与家人建立新关系',
    slug: 'life-after-coming-out',
    categoryId: 'shequn',
    categoryName: '社群互动',
    excerpt: '出柜是人生中的重要一步。本文分享了几位社群成员出柜后的真实经历，以及他们如何与家人重建关系的宝贵经验。',
    content: `<p>出柜是人生中的重要一步。本文分享了几位社群成员出柜后的真实经历，以及他们如何与家人重建关系的宝贵经验。</p>

<h2>给自己和家人时间</h2>
<p>出柜不是终点，而是新的开始。家人可能需要时间来消化和接受这个信息。在这个过程中，保持耐心和沟通至关重要。很多家庭成员最终都会选择支持，只是需要一个适应的过程。</p>

<h2>分享真实的故事</h2>
<p>社群成员阿杰分享道："我出柜后，妈妈整整沉默了三个月。但当我开始跟她分享我的日常生活、我的感受时，她慢慢开始理解和接受。"</p>

<h2>寻找专业支持</h2>
<p>如果家庭关系因为出柜变得紧张，不妨寻求专业的心理咨询。很多城市都有针对LGBTQ+群体的公益心理咨询服务。</p>`,
    author: '阿杰',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20friendly%20Asian%20male%20portrait%20avatar%20with%20confident%20smile%20on%20soft%20coral%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    publishDate: '2026-08-03',
    readTime: 10,
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20family%20living%20room%20scene%20with%20two%20people%20having%20a%20heartfelt%20conversation%20soft%20natural%20light%20coming%20through%20windows%20cozy%20atmosphere%20emotional%20editorial%20photography&width=800&height=450&seq=article-02&orientation=landscape',
    tags: ['出柜', '家庭关系', '心理支持'],
    featured: true,
  },
  {
    id: '3',
    title: '男同健康必修课：定期体检的重要性',
    slug: 'health-checkup-guide',
    categoryId: 'jiankang',
    categoryName: '健康指南',
    excerpt: '定期体检是守护健康的第一道防线。了解男同群体需要特别关注的健康项目，做到早预防、早发现、早治疗。',
    content: `<p>定期体检是守护健康的第一道防线。了解男同群体需要特别关注的健康项目，做到早预防、早发现、早治疗。</p>

<h2>为什么男同群体需要特别关注健康？</h2>
<p>由于生理特征和生活方式的特点，男同群体在某些健康风险上需要更加关注。定期体检可以帮助及早发现潜在问题，及时干预。</p>

<h2>必查项目清单</h2>
<p>除了常规体检项目外，建议男同群体特别关注：性传播疾病筛查、HIV检测、肛门健康检查、心理健康评估等项目。</p>

<h2>选择友善的医疗机构</h2>
<p>越来越多医疗机构开始提供LGBTQ+友善服务。选择一个让你感到舒适和受尊重的医疗环境，是坚持定期体检的重要保障。</p>`,
    author: '健康小助手',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20doctor%20avatar%20with%20kind%20smile%20on%20soft%20warm%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    publishDate: '2026-08-01',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20bright%20medical%20clinic%20interior%20with%20warm%20natural%20light%20friendly%20atmosphere%20clean%20minimal%20design%20professional%20healthcare%20setting%20editorial%20photography&width=800&height=450&seq=article-03&orientation=landscape',
    tags: ['健康体检', '疾病预防', '医疗资源'],
    featured: true,
  },
  {
    id: '4',
    title: '2026年全国男同骄傲月活动大盘点',
    slug: 'pride-month-2026-events',
    categoryId: 'huodong',
    categoryName: '活动信息',
    excerpt: '一年一度的骄傲月即将到来！我们整理了全国各地即将举办的男同相关活动，总有一场离你很近。',
    content: `<p>一年一度的骄傲月即将到来！我们整理了全国各地即将举办的男同相关活动，总有一场离你很近。</p>

<h2>北京站：彩虹跑</h2>
<p>时间：2026年6月15日<br/>地点：奥林匹克森林公园<br/>活动内容：5公里彩虹跑、音乐派对、公益市集</p>

<h2>上海站：骄傲电影节</h2>
<p>时间：2026年6月20日-25日<br/>地点：上海多家影院<br/>活动内容：LGBTQ+主题电影展映、导演见面会、映后座谈</p>

<h2>广州站：社群嘉年华</h2>
<p>时间：2026年6月28日<br/>地点：广州塔广场<br/>活动内容：文艺演出、互动游戏、交友速配、美食市集</p>`,
    author: '活动小喇叭',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Energetic%20Asian%20male%20avatar%20with%20bright%20smile%20on%20warm%20golden%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    publishDate: '2026-07-28',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20outdoor%20festival%20with%20happy%20people%20celebrating%20warm%20sunlight%20joyful%20atmosphere%20community%20gathering%20in%20a%20park%20vibrant%20yet%20tasteful%20editorial%20photography&width=800&height=450&seq=article-04&orientation=landscape',
    tags: ['骄傲月', '线下活动', '社群聚会'],
    featured: false,
  },
  {
    id: '5',
    title: '同志伴侣如何规划共同未来：财务与法律篇',
    slug: 'couple-financial-planning',
    categoryId: 'shenghuo',
    categoryName: '生活资讯',
    excerpt: '对于男同伴侣来说，财务规划和法律保障是长期关系的重要基石。了解如何共同规划未来，让爱情更有保障。',
    content: `<p>对于男同伴侣来说，财务规划和法律保障是长期关系的重要基石。了解如何共同规划未来，让爱情更有保障。</p>

<h2>财务规划从沟通开始</h2>
<p>很多伴侣回避谈钱，但坦诚的财务沟通是健康关系的重要组成部分。定期讨论收入、支出、储蓄目标和投资计划。</p>

<h2>法律工具的运用</h2>
<p>虽然全面婚姻平权仍在推进中，但现有的法律工具如意定监护、遗嘱、共有财产协议等，可以帮助伴侣在法律层面互相保护。</p>

<h2>保险规划</h2>
<p>合理配置保险，包括重疾险、医疗险和寿险，可以为伴侣提供经济安全网。</p>`,
    author: '理财达人Leo',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Smart%20professional%20Asian%20male%20avatar%20with%20warm%20smile%20on%20soft%20beige%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    publishDate: '2026-07-25',
    readTime: 9,
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20men%20sitting%20at%20a%20modern%20home%20office%20desk%20reviewing%20documents%20together%20warm%20natural%20light%20cozy%20atmosphere%20editorial%20photography%20clean%20composition&width=800&height=450&seq=article-05&orientation=landscape',
    tags: ['伴侣关系', '财务规划', '法律保障'],
    featured: false,
  },
  {
    id: '6',
    title: '男同群体的心理健康：打破沉默，勇敢求助',
    slug: 'mental-health-awareness',
    categoryId: 'jiankang',
    categoryName: '健康指南',
    excerpt: '心理健康与身体健康同等重要。本文讨论了男同群体常见的心理压力来源，以及如何有效应对。',
    content: `<p>心理健康与身体健康同等重要。本文讨论了男同群体常见的心理压力来源，以及如何有效应对。</p>

<h2>认识常见的心理压力</h2>
<p>社会偏见、身份认同、家庭关系、职场歧视等因素，都可能给男同群体带来额外的心理负担。认识到这些压力源是应对的第一步。</p>

<h2>建立支持网络</h2>
<p>一个理解和支持你的社交网络是心理健康的保护因素。男同网社群中有许多愿意倾听和分享的伙伴。</p>

<h2>专业帮助不可耻</h2>
<p>寻求心理咨询不是软弱的表现，而是关爱自己的勇敢行为。越来越多的心理咨询师提供LGBTQ+友善服务。</p>`,
    author: '心理咨询师小林',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Gentle%20caring%20Asian%20male%20therapist%20avatar%20with%20warm%20reassuring%20smile%20on%20soft%20peach%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-06&orientation=squarish',
    publishDate: '2026-07-20',
    readTime: 8,
    imageUrl: 'https://readdy.ai/api/search-image?query=Calm%20peaceful%20therapy%20room%20with%20warm%20light%20comfortable%20chairs%20soft%20textures%20plants%20creating%20a%20safe%20healing%20space%20editorial%20photography&width=800&height=450&seq=article-06&orientation=landscape',
    tags: ['心理健康', '压力管理', '心理咨询'],
    featured: false,
  },
  {
    id: '7',
    title: '同志友好城市指南：中国最包容的城市TOP5',
    slug: 'lgbtq-friendly-cities',
    categoryId: 'shenghuo',
    categoryName: '生活资讯',
    excerpt: '选择一个包容的城市生活，对男同群体的幸福感至关重要。我们盘点了中国最包容的5座城市。',
    content: `<p>选择一个包容的城市生活，对男同群体的幸福感至关重要。我们盘点了中国最包容的5座城市。</p>

<h2>上海</h2>
<p>作为国际化大都市，上海拥有活跃的LGBTQ+社群和丰富的线下活动。从法租界的同志友好酒吧到定期的社群聚会，上海的包容度在国内领先。</p>

<h2>北京</h2>
<p>北京拥有众多LGBTQ+公益组织和丰富的文化活动。北京同志中心等机构长期为社群提供支持和服务。</p>

<h2>成都</h2>
<p>成都是国内公认的对LGBTQ+群体最友好的城市之一。悠闲的生活节奏和包容的城市文化，让这里成为很多男同的理想居住地。</p>`,
    author: '城市探索者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Travel%20loving%20Asian%20male%20avatar%20with%20adventurous%20smile%20on%20soft%20warm%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-07&orientation=squarish',
    publishDate: '2026-07-15',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20Chinese%20city%20skyline%20at%20sunset%20with%20warm%20golden%20light%20reflecting%20on%20buildings%20inclusive%20vibrant%20urban%20atmosphere%20editorial%20photography&width=800&height=450&seq=article-07&orientation=landscape',
    tags: ['城市生活', '包容性', '居住指南'],
    featured: false,
  },
  {
    id: '8',
    title: '线上交友聊天技巧：如何开启有意义的对话',
    slug: 'online-dating-chat-tips',
    categoryId: 'jiaoyou',
    categoryName: '男同交友',
    excerpt: '"嗨"之后呢？很多人在线上交友时不知道如何延续对话。本文分享实用技巧，帮你轻松破冰。',
    content: `<p>"嗨"之后呢？很多人在线上交友时不知道如何延续对话。本文分享实用技巧，帮你轻松破冰。</p>

<h2>从对方资料找话题</h2>
<p>仔细看对方的资料，找到你们共同的兴趣爱好，这将是最自然的聊天切入点。</p>

<h2>开放式问题的魅力</h2>
<p>多问开放式问题（需要对方展开回答的问题），少问只有"是/否"答案的封闭式问题。</p>

<h2>真诚是最好的技巧</h2>
<p>无论用什么聊天技巧，真诚永远是最重要的。做真实的自己，才能吸引到真正适合你的人。</p>`,
    author: '社交达人阿Ken',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Charismatic%20Asian%20male%20avatar%20with%20friendly%20smile%20on%20soft%20rose%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-08&orientation=squarish',
    publishDate: '2026-07-10',
    readTime: 6,
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20people%20sitting%20on%20a%20park%20bench%20having%20a%20friendly%20conversation%20warm%20afternoon%20sunlight%20through%20trees%20natural%20relaxed%20atmosphere%20editorial%20photography&width=800&height=450&seq=article-08&orientation=landscape',
    tags: ['聊天技巧', '线上交友', '社交指南'],
    featured: false,
  },
  {
    id: '9',
    title: '男同社群的力量：为什么你需要一个支持圈',
    slug: 'power-of-community-support',
    categoryId: 'shequn',
    categoryName: '社群互动',
    excerpt: '拥有一个理解你、支持你的社群，对男同群体的身心健康有深远影响。本文探讨社群支持的重要性。',
    content: `<p>拥有一个理解你、支持你的社群，对男同群体的身心健康有深远影响。本文探讨社群支持的重要性。</p>

<h2>归属感的力量</h2>
<p>在一个可能仍然存在偏见的世界里，找到一个让你感到被接纳的社群，是维护心理健康的重要方式。</p>

<h2>互相扶持，共同成长</h2>
<p>社群不仅提供情感支持，也是分享资源、交流经验、共同成长的平台。从职业发展到个人成长，社群成员可以互相帮助。</p>`,
    author: '社群志愿者大海',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Warm%20kind%20Asian%20male%20volunteer%20avatar%20with%20gentle%20smile%20on%20soft%20warm%20gradient%20background%20minimal%20illustration%20style&width=100&height=100&seq=avatar-09&orientation=squarish',
    publishDate: '2026-07-05',
    readTime: 7,
    imageUrl: 'https://readdy.ai/api/search-image?query=Diverse%20group%20of%20friends%20sitting%20in%20a%20circle%20in%20a%20cozy%20living%20room%20warm%20lighting%20supportive%20atmosphere%20community%20gathering%20editorial%20photography&width=800&height=450&seq=article-09&orientation=landscape',
    tags: ['社群力量', '归属感', '支持网络'],
    featured: false,
  },
];